import classes from './Sample.module.css';
import Process from './Process';
import Measurement from './Measurement';
import GoNoGo from './GoNoGo';
import CycleInfo from './CycleInfo';

function Sample(props) {

  function getTextWidth(text, font) {
    // Create a canvas element
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    // Set the font for the context
    context.font = font;
    // Measure the width of the text
    const width = context.measureText(text).width;
    // Return the width
    return width;
}

    let plot_cycles = []
    // Create Cycle Info
    if (props.sample) {
      // Here we collect relevant properties for the shape of an Element as Defined in Element.module.css
      // Units are in 'px'
      let outer_container_margin_left = 10;
      let outer_container_margin_right = 10;
      let color_block_container_width = 180;

      // Pin sizes are defined in FactorPin.jsx, ConditionPin.jsx and MeasurementPin.jsx
      function width_outer(len) { return (len+10) + 20 + 8; }

      for (let i=0; i<props.sample.cycles.length; i++) {
        let cycle_posx = 0
        let cycle_width = 0
        // get string element of the cylce
        let start_elem_id = Math.min(...props.sample.cycles[i].cycle_elements);

        // compute postion of the first cycle: For all previous elments cycle_posx += element_width; cycle_posx += pin_lenghts; cycle_posx += margins
        cycle_posx = outer_container_margin_left
        // iterate through all elements that are between this and the last cycle
        if(i===0) { // if first cycle - iterate through all elemnts that are before the first cycle
          for (let j=0; j<start_elem_id; j++){
            cycle_posx += outer_container_margin_left;
            cycle_posx += color_block_container_width;
            cycle_posx += outer_container_margin_right;
            if (props.sample.elements[j].pins.length>0) {
              let max_length_pinname = Math.max(props.sample.elements[j].pins.reduce((max, pin) => Math.max(max, getTextWidth(pin.name, '14px Roboto')), 0), 60) ;
              cycle_posx += width_outer(max_length_pinname);
            }
          }
        }
        else {
          let elem_id_last_cycle = Math.max(...props.sample.cycles[i-1].cycle_elements);
          cycle_posx += outer_container_margin_right
          for (let j=elem_id_last_cycle+1; j<start_elem_id; j++){
            cycle_posx += outer_container_margin_left;
            cycle_posx += color_block_container_width;
            cycle_posx += outer_container_margin_right;
            if (props.sample.elements[j].pins.length>0) {
              let max_length_pinname = Math.max(props.sample.elements[j].pins.reduce((max, pin) => Math.max(max, getTextWidth(pin.name, '14px Roboto')), 0), 60) ;
              cycle_posx += width_outer(max_length_pinname);
            }
          }
        }

        // compute cycle_width: For all elments in cycle cycle_width += element_width; cycle_width += pin_lenghts; cycle_width += margins
        // iterate through all previous elements
        cycle_width = -outer_container_margin_right-outer_container_margin_left;
        for (let j=0; j<props.sample.cycles[i].cycle_elements.length; j++){
          cycle_width += outer_container_margin_left;
          cycle_width += color_block_container_width;
          cycle_width += outer_container_margin_right;
          let elem_id = props.sample.cycles[i].cycle_elements[j];
          if (props.sample.elements[elem_id].pins.length>0) {
            let max_length_pinname = Math.max(props.sample.elements[elem_id].pins.reduce((max, pin) => Math.max(max, getTextWidth(pin.name, '14px Roboto')), 0), 60) ;
            cycle_width += width_outer(max_length_pinname);
          }
        }
        plot_cycles.push( <div key={`cycle_${props.sid}_${i}`} style={{position:'relative', marginLeft:`${cycle_posx}px`, display:'block', gap:'0px', width:'fit-content', height:'fit-content'}}>
                            <CycleInfo cycle_id={`${props.sid}_${i}`} 
                                        width={cycle_width}
                                        cycle_info={props.sample.cycles[i]}
                                        sample_parallel={''} 
                                        cycle_time={''} 
                                        handleInputData={props.handleCycleInfo}
                              />
                          </div>)

        }
    }

    let elements = (<></>)
    if (props.sample.elements) {        
        let max_num_pins = props.sample.elements.reduce((max, element) => Math.max(max, element.pins.length), 0);
        elements = props.sample.elements.map((element, elementIndex) => {
          let isLast = false;
          let isFirst = false;
          if(elementIndex === 0) { isFirst = true; }
          if(elementIndex === props.sample.elements.length -1 ) { isLast = true;}
          if (element.type === 'Process') {
            return (
              <Process
                elem_id={`${props.sid}_${elementIndex}`}
                key={`S${props.sid}_${elementIndex}`}
                element={element}
                max_num_pins={max_num_pins}
                handleEnterName={props.handleElementName}
                handleDelete={props.handleDeleteElement}
                handleAddPin={props.handleAddPin}
                handlePinName={props.handlePinName}
                handleRemovePin={props.handleRemovePin}
                handleMoveLeft={props.handleMoveLeft}
                handleMoveRight={props.handleMoveRight}
                isFirstElement={isFirst}
                isLastElement={isLast}
              />
            );
          }
          if (element.type === 'Measurement') {
            return (
              <Measurement
                elem_id={`${props.sid}_${elementIndex}`}
                key={`S${props.sid}_${elementIndex}`}
                element={element}
                max_num_pins={max_num_pins}
                handleEnterName={props.handleElementName}
                handleDelete={props.handleDeleteElement}
                handleAddPin={props.handleAddPin}
                handlePinName={props.handlePinName}
                handleRemovePin={props.handleRemovePin}
                handleMoveLeft={props.handleMoveLeft}
                handleMoveRight={props.handleMoveRight}
                isFirstElement={isFirst}
                isLastElement={isLast}
              />
            );
          }
          if (element.type === 'GoNoGo') {
            return (
              <GoNoGo
                elem_id={`${props.sid}_${elementIndex}`}
                key={`S${props.sid}_${elementIndex}`}
                element={element}
                max_num_pins={max_num_pins}
                handleEnterName={props.handleElementName}
                handleDelete={props.handleDeleteElement}
                handleAddPin={props.handleAddPin}
                handlePinName={props.handlePinName}
                handleRemovePin={props.handleRemovePin}
                handleMoveLeft={props.handleMoveLeft}
                handleMoveRight={props.handleMoveRight}
                isFirstElement={isFirst}
                isLastElement={isLast}
              />
            );
          }
          return null; // Return null for other types or no types
        });
      }

    if(props.sample)
    {
        return (
                <>
                    <div id={props.sid} className={classes.container_sample} >
                        <div style ={{ position:'relative', marginTop:'5px', marginBottom:'25px',marginLeft:'0px', marginRight:'0px', display:'flex', height: 'fit-content', width:'100%'}}>
                                <button id={'add_Process_'+props.sid} className={`${classes.button} ${classes.green}`} onClick={props.addBlock} >add process</button>
                                <button id={'add_Measurement_'+props.sid} className={`${classes.button} ${classes.red}`} onClick={props.addBlock} >add measurement</button>
                                <button id={'add_GoNoGo_'+props.sid} className={`${classes.button} ${classes.blue}`} onClick={props.addBlock} >add go/nogo</button>
                                <button id={'remove_'+props.sid} className={`${classes.button} ${classes.black}`} onClick={props.remove} >delete sample</button>
                        </div>
                        <div style={{position:'relative', display:'flex', flexDirection: 'row'}}>
                          {plot_cycles}
                        </div>
                        <div id="container_elements" className={classes.container_elements} >
                            {elements}
                        </div>
                        <div id="lineage" className={classes.sample_footer}>  
                            <input id={"samplename_"+props.sid} value={props.sample.name} autoComplete='new-password' placeholder='Name: Sample Lineage' className={classes.sample_name} onChange={props.handleSampleName} />
                        </div>
                    </div>
                </>  ) ;
        }
    }
    
    export default Sample;